import { round } from "lodash";
import React from "react";
import {
  AreaChart,
  Area,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from "recharts";
import { formatAreaChart } from "../body-composition.helper";
import NoData from "./NoData";

const AreaGraph = ({
  data,
  targetValue,
  graphId,
  label = "",
  description = "",
  units = "",
  noTooltip = false,
}) => {
  const mappedData = data
    .filter((data) => data[targetValue] > 0)
    .map((data) => formatAreaChart(data, targetValue));

  const valuesArray = mappedData.map((data) => data.value);
  const maxValue = Math.trunc(Math.max(...valuesArray)) + 2;
  const minValue = Math.trunc(Math.min(...valuesArray)) - 2;

  if (!mappedData.length) {
    return <NoData />;
  }

  return (
    <ResponsiveContainer width={"99%"} heigh={"45%"} aspect={2} id={graphId}>
      <AreaChart data={mappedData}>
        <CartesianGrid
          stroke="var(--grid-chart-line)"
          strokeDasharray="5 5"
          strokeWidth={1}
          horizontal={true}
          vertical={false}
          margin={{ top: 0 }}
        />
        <XAxis
          dataKey="date"
          ticks={[
            mappedData[0].date,
            mappedData[mappedData.length - 1 || 0].date,
          ]}
          interval={"preserveStartEnd"}
          fontSize={"12"}
          offset={"12"}
          tick={{ fill: "var(--white)" }}
          dy={5}
          hide={noTooltip}
        />
        <YAxis hide={true} type={"number"} domain={[minValue, maxValue]} />
        {!noTooltip && (
          <Tooltip
            content={
              <CustomTooltip
                customLabel={label}
                description={description}
                units={units}
              />
            }
          />
        )}
        <Area
          type="monotone"
          dataKey="value"
          stroke="#00afe4"
          fill="#00afe4"
          strokeWidth={2}
        />
      </AreaChart>
    </ResponsiveContainer>
  );
};

// To show the tooltip with a different style and information
const CustomTooltip = ({
  active,
  payload,
  customLabel,
  description,
  units,
}) => {
  // the condition for the length of the payload is for the first point of the line
  // as that one only has a target of 0, making the lenth 1

  if (active && payload && payload.length > 0) {
    //   // The payload is an array of objects, the structure would always be like this,
    //   // As the time of writing, there are not more than one value displayed
    //   // [
    //   //   {name: "value", value: 0, payload: { date: 'Aug 13, 2021' }, ...}
    //   // ]
    //
    return (
      <div className="custom-tooltip">
        <div>
          {customLabel} ({payload[0].payload.date})
        </div>
        <div>
          <span className="clipped">
            {description}: {round(payload[0].value, 1)} {units}
          </span>
        </div>
      </div>
    );
  }

  return null;
};

export default AreaGraph;
